import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UserPosition } from 'data/model'
import { produce } from 'immer'
import { userConfig } from 'lib/config'

import { UserState } from '../model/user'

const initialState: UserState = {
  browserPosition: { accuracy: null, coordinates: null },
  countryCode: userConfig.countryCode,
  currentPosition: { accuracy: null, coordinates: null },
  error: null,
  isLoading: false,
}

const userSlice = createSlice({
  initialState,
  name: 'user',
  reducers: {
    fetchCurrentPosition(state: UserState) {
      return produce(state, (draft) => {
        draft.isLoading = true
      })
    },
    setBrowserPosition(state: UserState, action: PayloadAction<UserPosition>) {
      return produce(state, (draft) => {
        draft.browserPosition = action.payload
      })
    },
    setCountryCode(state: UserState, action: PayloadAction<string>) {
      return produce(state, (draft) => {
        draft.countryCode = action.payload
      })
    },
    setCurrentPosition(state: UserState, action: PayloadAction<UserPosition>) {
      return produce(state, (draft) => {
        draft.currentPosition = action.payload
      })
    },
    setError(state: UserState, action: PayloadAction<string>) {
      return produce(state, (draft) => {
        draft.error = action.payload
      })
    },
  },
})

export const {
  setCountryCode,
  fetchCurrentPosition,
  setBrowserPosition,
  setCurrentPosition,
  setError,
} = userSlice.actions

export const reducer = userSlice.reducer
